import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import ReactPlayer from "react-player";
import { serviceVideo } from "../constant/Index";
import WhatsAppButton from "../components/WhatsAppButton";
import Footer from "../components/Footer";

gsap.registerPlugin(ScrollTrigger);

const Services = () => {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.to(".hero_txt", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
    });
    tl.to(".hero_txt11", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
    });
  });

  return (
    <>
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-12 ">
            <h2 className="first-text-page text-center">How We Help You Win</h2>
            <ReactPlayer
              width="100%"
              height="100%"
              url={serviceVideo}
              loop={true}
              playing={true}
              muted={true}
            />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="content-service-sec ">
              <h2>Web Designing and Development</h2>
              <p>
                In the digital world, your website is not just a virtual
                address, it's your welcoming storefront, your brand ambassador,
                and your conversion champion.{" "}
                <span className="hero_txt">CrispBrains</span>, with its
                dedicated team of design and development experts, unlocks the
                magic of captivating websites. We craft unique, user-friendly,
                and visually striking online experiences that reflect your brand
                and convert visitors into customers. From custom website design
                and development to robust e-commerce solutions and ongoing
                maintenance, we ensure your online haven runs smoothly, drives
                engagement, and fuels your growth.{" "}
              </p>
              <p>
                Ditch the outdated design and say hello to a website that works
                harder than ever. Contact{" "}
                <span className="hero_txt">CrispBrains</span> today and discover
                the magic of a website that truly elevates your brand.
              </p>
              <h2 className="mt-5">
                <span className="hero_txt">CrispBrains</span>: Where Design
                Meets Digital Brilliance
              </h2>
              <p>
                Your brand deserves more than just a logo and website. It
                deserves a visually stunning story that resonates with your
                audience and fuels your success. At{" "}
                <span className="hero_txt">CrispBrains</span>, we're not just
                digital marketing masters, we're design artisans who breathe
                life into your brand identity.
              </p>
              <p>
                <b>From pixels to packaging, we craft experiences that:</b>
              </p>
              <div className="points-sec">
                <ul>
                  <li>
                    Turn heads: Our designers are visionaries, conjuring
                    eye-catching logos, websites, and packaging that make your
                    brand pop. We capture your essence and translate it into
                    visual elements that leave a lasting impression.
                  </li>
                  <li>
                    Tell your story: Design is more than aesthetics; it's about
                    communication. We help you articulate your unique values and
                    vision through a cohesive visual language that speaks
                    volumes to your target audience.
                  </li>
                  <li>
                    Drive results: Good design isn't just pretty, it's
                    strategically impactful. We design with conversion in mind,
                    crafting websites that guide users seamlessly towards your
                    desired actions.
                  </li>
                </ul>
              </div>

              <p>
                <b>Our design services encompass:</b>{" "}
              </p>
              <div className="points-sec">
                <ul>
                  <li>
                    <b>Website design and development:</b> From sleek and modern
                    to playful and engaging, we create websites that are not
                    just functional, but captivating.
                  </li>
                  <li>
                    <b>Logo design: </b>
                    Your logo is your brand's face, and we make sure it's
                    unforgettable. We create logos that are unique, memorable,
                    and perfectly represent your essence.
                  </li>
                  <li>
                    <b>Branding and identity: </b>
                    <p>
                      We delve deep into your brand's DNA, crafting a
                      comprehensive visual identity that permeates all
                      touchpoints, from your website to your social media.
                    </p>
                  </li>
                  <li>
                    <b>Packaging design: </b>
                    Make your products stand out on the shelf with packaging
                    that is both aesthetically pleasing and functionally sound.
                  </li>
                  <li>
                    <b>Resume and portfolio design: </b>
                    <p>
                      Get noticed by potential employers with a resume or
                      portfolio that showcases your skills and personality in a
                      visually compelling way.
                    </p>
                  </li>
                </ul>
              </div>
              <p>
                Don't let your brand get lost in the digital crowd. Partner with
                <span className="hero_txt">CrispBrains</span> and unlock the
                power of design to elevate your online presence and achieve your
                business goals.{" "}
              </p>
              <p>
                Contact us today for a free consultation and let's bring your
                brand vision to life!
              </p>
              <p>
                Spark Conversations, Ignite Engagement:{" "}
                <span className="hero_txt">CrispBrains</span> Social Media
                Marketing
              </p>
              <p>
                Gone are the days of one-way broadcasts. Today, social media is
                the pulse of customer connection, where brands spark
                conversations and build thriving communities. But navigating
                this vibrant landscape takes expertise.
              </p>
              <h2 className="mt-5">
                <span className="hero_txt">CrispBrains</span> empowers
                businesses to:
              </h2>
              <div className="points-sec">
                <ul>
                  <li>
                    Find your voice: We unearth your unique brand personality
                    and translate it into engaging social content.
                  </li>
                  <li>
                    Target the right audience: We pinpoint your ideal customers
                    on the platforms they frequent and build targeted campaigns
                    that resonate.
                  </li>
                  <li>
                    Fuel interaction: We craft compelling content that sparks
                    conversations, fosters loyalty, and drives action.
                  </li>
                  <li>
                    Track and measure: We leverage data insights to continuously
                    improve your social media performance and maximize ROI.
                  </li>
                </ul>
              </div>
              <p>
                Don't just post, connect. Partner with{" "}
                <span className="hero_txt">CrispBrains</span> and watch your
                social media presence transform into a powerful engine for
                customer engagement and brand advocacy.
              </p>
              <h2 className="mt-5">
                Unleash the Power of SEO with{" "}
                <span className="hero_txt">CrispBrains</span>
              </h2>
              <p>
                Getting found online matters. That's where SEO comes in – the
                key to placing your website front and center when customers
                search for your products or services. At{" "}
                <span className="hero_txt">CrispBrains</span>, we understand the
                intricate dance of search engine algorithms and leverage our
                expertise to:
              </p>
              <div className="points-sec">
                <ul>
                  <li>
                    Optimize your website: We analyze your site and content,
                    identifying opportunities to improve structure, keywords,
                    and technical elements for better search engine visibility.
                  </li>
                  <li>
                    Craft search-friendly content: Our content curators create
                    high-quality, engaging content that speaks directly to your
                    target audience and resonates with search engines.
                  </li>
                  <li>
                    Build links and authority: We implement strategic
                    link-building strategies that establish your website as a
                    trusted source in your industry.
                  </li>
                  <li>
                    Track and measure: We monitor your progress and provide
                    data-driven insights to continually refine your SEO efforts.
                  </li>
                </ul>
              </div>
              <p>
                Don't settle for lost opportunities. Partner with{" "}
                <span className="hero_txt">CrispBrains</span> and watch your
                organic traffic soar, bringing qualified leads and boosting your
                bottom line.
              </p>
              <h2 className="mt-5">Dominate Search Results with Paid Search</h2>
              <p>
                Skip the wait and connect with customers actively searching for
                your products or services. Paid search advertising puts your
                brand at the top of search engine results pages (SERPs) like
                Google and Bing, where high-intent leads await. But that's not
                all! We also master the art of targeting on social media
                platforms like Facebook and Instagram, allowing you to reach
                your ideal audience across all digital touchpoints.
              </p>
              <p>
                <span className="hero_txt">CrispBrains</span> crafts impactful
                paid search and social media campaigns that deliver:
              </p>
              <div className="points-sec">
                <ul>
                  <li>
                    Targeted reach: We pinpoint your ideal customers with laser
                    precision, ensuring your ads reach the right people at the
                    right time, whether they're browsing search engines or
                    scrolling through their social media feeds.
                  </li>
                  <li>
                    Maximum visibility: Secure prime placement on SERPs and
                    strategic positions on Facebook and Instagram, capturing
                    attention and driving clicks to your website.
                  </li>
                  <li>
                    Measurable results: We track every click, conversion, and
                    cost, optimizing your campaigns across all platforms for
                    maximum ROI.
                  </li>
                  <li>
                    Brand awareness boost: Build brand recognition and generate
                    valuable leads by staying top-of-mind for potential
                    customers both on search engines and social media.
                  </li>
                </ul>
              </div>
              <p>
                Don't just compete, conquer digital. Let{" "}
                <span className="hero_txt">CrispBrains</span> be your paid
                search and social media partner and transform your online
                visibility into tangible results.
              </p>
            </div>
          </div>
        </div>
      </div>
      <WhatsAppButton />
      <Footer />
    </>
  );
};

export default Services;
